export const unreadChatLabel = count => count > 0
  ? `Chat, ${count} unread ${count === 1 ? 'message' : 'messages'}` : 'Chat';

export const PortalUnreadBadge = ({ count, testId, floating = false }) => count > 0 && (
  <span className={`portal-unread-badge${floating ? ' portal-unread-floating' : ''}`}
    data-testid={testId} aria-hidden="true">{count > 99 ? '99+' : count}</span>
);